/*
 * @Author: zzz
 * @Date: 2021-01-26 15:49:46
 * @LastEditTime: 2021-01-28 16:56:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \04eos-app\src\pages\rank\attr.js
 */
export const tabsData = [
  {
    title: '今日试驾',
    label: 'followUp'
  },
  {
    title: 'PDC',
    label: 'PDC'
  },
  { 
    title: 'TD No-Show',
    label: 'TDNoShow'
  },
  {
    title: 'TD Follow Up',
    label: 'TDFollowUp'
  }
]
